import { useEffect, useRef, useCallback } from 'react';

export function useWebSocket(onMessage: (data: any) => void) {
  const ws = useRef<WebSocket | null>(null);
  const reconnect = useRef<NodeJS.Timeout>();

  const connect = useCallback(() => {
    const WS = process.env.REACT_APP_WS_URL || 'ws://localhost:8000';
    ws.current = new WebSocket(`${WS}/ws/events/`);
    ws.current.onmessage = e => { try { onMessage(JSON.parse(e.data)); } catch {} };
    ws.current.onclose = () => { reconnect.current = setTimeout(connect, 3000); };
    ws.current.onerror = () => ws.current?.close();
  }, [onMessage]);

  useEffect(() => {
    connect();
    return () => { clearTimeout(reconnect.current); ws.current?.close(); };
  }, [connect]);
}
